module.exports = "/images/vendor/svg-country-flags/svg/de.svg?cfbb0cf09f502653fe85aed9bd14d4ef";